export default __webpack_public_path__ + "static/media/paid-by-cash-card.d9a8c6a9.svg";